import type {ReactElement} from 'react';
import React from 'react';
import {BaseEditContentOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-edit-content-option';
import {openEditMenuModal} from '@Components/poster-editor/library/poster-editor-open-modals';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

export function MenuEditContentOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;

  if (!activeItem || (activeItem && !activeItem.isMenu())) {
    throw new Error('Active item is not of type menu!');
  }

  const openModal = (): void => {
    openEditMenuModal(activeItem);
  };

  return (
    <BaseEditContentOption
      onClick={(): void => {
        openModal();
      }}
    />
  );
}
